/**
 * RelatorioGeracaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'

/* TODO: review generated class */
@HttpExclude()
export class RelatorioGeracaoCollection extends PageCollection<
  RelatorioGeracao
> {
  constructor() {
    super(RelatorioGeracao)
  }

  queryAsPage() {
    return this.listRelatorioGeracao()
  }

  async listRelatorioGeracao() {
    return await Request.get(`/admin/relatorio-geracao`, {params: this.params})
      .name('listRelatorioGeracao')
      .as(this)
      .getResponse()
  }

  async listCsvRelatorioGeracao() {
    return await Request.get(`/admin/relatorio-geracao/csv`, {
      params: this.params,
    })
      .name('listCsvRelatorioGeracao')
      .as(this)
      .getResponse()
  }
}
